module.exports = __webpack_public_path__ + "static/media/Костенко И., Малютин К.  (КФА).5ebe5b59.pdf";